<div class="min-vh-100 bg-light">
  <app-header [page]="'Notifications'"></app-header>

  <main class="container py-4">
    <div class="d-flex flex-wrap justify-content-between align-items-start gap-3 mb-4">
      <div>
        <h4 class="fw-bold mb-1">Notifications</h4>
        <div class="text-muted">Updates that require your attention.</div>
      </div>
      <div class="d-flex flex-wrap gap-2">
        <select class="form-select form-select-sm" [(ngModel)]="filter" (change)="load(1)">
          <option value="all">All notifications</option>
          <option value="unread">Unread</option>
          <option value="read">Read</option>
        </select>
        <button class="btn btn-outline-primary btn-sm" type="button" (click)="markAllRead()" [disabled]="markingAll">
          {{ markingAll ? 'Updating...' : 'Mark all read' }}
        </button>
      </div>
    </div>

    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

    <div class="card border-0 shadow-sm">
      <div *ngIf="loading" class="card-body text-center py-5">
        <div class="spinner-border spinner-border-sm me-2"></div>Loading notifications...
      </div>

      <div class="list-group list-group-flush" *ngIf="!loading && items.length">
        <button type="button" class="list-group-item list-group-item-action p-3"
          *ngFor="let item of items" [class.notification-unread]="!item.isRead" (click)="open(item)">
          <div class="d-flex gap-3 align-items-start">
            <span class="notification-icon" [ngClass]="typeClass(item.type)">{{ typeIcon(item.type) }}</span>
            <div class="flex-grow-1 text-start">
              <div class="d-flex justify-content-between gap-3">
                <div class="fw-semibold">{{ item.title }}</div>
                <span *ngIf="!item.isRead" class="badge rounded-pill text-bg-primary">New</span>
              </div>
              <div class="small mt-1">{{ item.message }}</div>
              <div class="text-muted small mt-2">{{ item.createdAt | date:'medium' }}</div>
            </div>
            <span *ngIf="item.actionUrl" class="text-muted">›</span>
          </div>
        </button>
      </div>

      <div *ngIf="!loading && !items.length" class="card-body text-center py-5">
        <div class="fs-1 mb-2">🔔</div>
        <h5>No notifications found</h5>
        <p class="text-muted mb-0">There are no notifications matching this filter.</p>
      </div>
    </div>

    <app-pagination *ngIf="meta && meta.totalRows > 0" url="account/notifications" [counts]="meta" (refresh)="load($event)"></app-pagination>
    <app-footer></app-footer>
  </main>
</div>
